import React, { Component } from 'react';
import { withRouter, setCookie, login_check, deleteCookie, getCookie, loginUrl, pocketUrl, isLogin } from './include/Common';
import {Helmet} from 'react-helmet';

import $ from 'jquery';
import axios from "axios";
import { Navigate } from "react-router-dom";
import Footer from './Footer';
//
class MyQuiz extends Component {
   constructor(props) {
      super(props);
      this.state = {
         isLogin: false,   // 처음에 로딩 상태
         loading: true,
         formatted: '',
         formMonth: '',
         formWeek: '',
         ord: 'all',
         currDate: '',
         mw:false,
         quizList: []
      };
   }
   componentDidMount() {
      // 페이지 로드 시 axios 호출

      this.loadScript();
      $(document).on("click", ".comboBx__btn", function (e) {
         e.stopPropagation();

         const $btn = $(this);
         const $combo = $btn.closest(".comboBx");
         const $list = $combo.find(".comboBx__list");

         const isActive = $btn.hasClass("active");

         // 모든 콤보 초기화
         $(".comboBx__btn").removeClass("active");
         $(".comboBx__list").hide();

         // 현재 클릭한 것만 toggle
         if (!isActive) {
            $btn.addClass("active");
            $list.show();
         }
      });

      // 바깥 클릭 시 모든 콤보 닫기
      $(document).on("click", function () {
         $(".comboBx__btn").removeClass("active");
         $(".comboBx__list").hide();
      });

   }

   async fetchAccessCheck(currentDate, ord) {
      const publicUrl = process.env.PUBLIC_URL;

      if (currentDate != '') {
         $('.comboBx__btn').text('전체');
         this.setState({
            ord: 'all',
            currDate: currentDate
         });
      }
      const { currDate } = this.state;

      if (currentDate == '' || currentDate == undefined) currentDate = currDate;

      let quizHistoryUrl = publicUrl + '/api/getQuizHistory.php?dt=' + currentDate + '&md=quiz&ord=' + ord;
      //console.log(quizHistoryUrl);
      let response = await axios.get(quizHistoryUrl);
      const quizData = response.data;
      //console.table(quizData);
      if (!quizData.login) {
         window.location.href = loginUrl + '?ref=' + pocketUrl + '/MyQuiz';
      }
      const weekTextContainer = document.querySelector('.week-selector__text');
      if (!weekTextContainer) return;

      const retForm = quizData.dateInfo.formatted.split("|");
      const spans = weekTextContainer.querySelectorAll('span');
      if (spans.length >= 2) {
         spans[0].textContent = retForm[0];
         spans[1].textContent = retForm[1];
      }
      this.setState({
         formMonth: retForm[0],
         formWeek: retForm[1]
      });
      const quizItems = Object.keys(quizData)
         .filter(key => !isNaN(key))
         .map(key => quizData[key]);
      this.setState({
         quizList: quizItems,
         formatted: quizData.dateInfo.formatted,
         weekusercnt: quizData.weekusercnt,
         mw: quizData.dateInfo.mw,
         loading: false
      });

   }

   loadScript() {
      // 캘린더 닫기버튼 추가
      function insertCloseButton(instance) {
         const calendar = instance.calendarContainer;
         if (!calendar.querySelector('.flatpickr-close-btn')) {
            const closeBtn = document.createElement('button');
            closeBtn.title = '닫기';
            closeBtn.className = 'flatpickr-close-btn';
            closeBtn.addEventListener('click', () => {
               instance.close();
            });
            calendar.appendChild(closeBtn);
         }
      }

      // 주의 시작일 (월요일) 반환
      function getStartOfWeek(d) {
         const date = new Date(d);
         const day = date.getDay(); // 일:0 ~ 토:6
         const diff = (day === 0 ? -6 : 1) - day; // 월요일 시작
         date.setDate(date.getDate() + diff);
         date.setHours(0, 0, 0, 0);
         return date;
      }
      function getEndOfWeek(date) {
         const start = getStartOfWeek(date);
         return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
      }
      // 이번 주의 마지막 날 계산 (일요일)
      function getEndOfThisWeek() {
         const now = new Date();
         const start = getStartOfWeek(now);
         return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
      }

      // 월/주차 표시 업데이트
      function updateWeekText(date) {
         const weekTextContainer = document.querySelector('.week-selector__text');
         if (!weekTextContainer) return;
         const { formatted } = this.state;

         const retForm = formatted.split("|");
         /*
                  const year = date.getFullYear();
                  const month = date.getMonth() + 1;
         
                  const firstDayOfMonth = new Date(year, date.getMonth(), 1);
                  const firstDayWeekday = firstDayOfMonth.getDay(); // 0=일~6=토
         
                  let week1Start;
         
                  if (firstDayWeekday >= 5) {
                     // 금요일(5)~토요일(6): 전월 마지막 주
                     week1Start = getStartOfWeek(firstDayOfMonth);
                  } else {
                     // 일~목: 해당월 1주차
                     week1Start = firstDayOfMonth;
                  }
         
                  const diffTime = date - week1Start;
                  const weekIndex = Math.floor(diffTime / (7 * 24 * 60 * 60 * 1000)) + 1;
         */
         const spans = weekTextContainer.querySelectorAll('span');
         if (spans.length >= 2) {
            spans[0].textContent = retForm[0];
            spans[1].textContent = retForm[1];
         }
      }

      // flatpickr 헤더 커스터마이징 (옵션용)
      function updateHeader(selectedDates, dateStr, instance) {
         const monthElement = instance.currentMonth;
         const year = instance.currentYear;
         const koreanMonths = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
         const customLabel = `${year}년 ${koreanMonths[monthElement]}`;

         const currentMonthElem = instance.calendarContainer.querySelector('.flatpickr-current-month');
         if (currentMonthElem) {
            currentMonthElem.innerHTML = `<span class="cur-month">${customLabel}</span>`;
         }
      }

      // 내비게이션 버튼 활성/비활성 업데이트
      function updateNavButtons() {
         const prevBtn = document.querySelector('.week-selector__nav--prev');
         const nextBtn = document.querySelector('.week-selector__nav--next');

         prevBtn.disabled = false;

         const nextWeekStart = new Date(currentDate);
         nextWeekStart.setDate(currentDate.getDate() + 7);
         nextBtn.disabled = nextWeekStart > maxDate;
      }
      const getToday = () => {
         const today = new Date();
         const year = today.getFullYear();
         const month = String(today.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
         const day = String(today.getDate()).padStart(2, '0');
         return `${year}-${month}-${day}`;
      };

      // 초기 설정
      const maxDate = getEndOfThisWeek();

      const stateDate = this.props.params.stext || getToday();
      const tdate = stateDate ? new Date(stateDate) : new Date();
      const sY = tdate.getFullYear();
      const sm = String(tdate.getMonth() + 1).padStart(2, '0');
      const sd = String(tdate.getDate()).padStart(2, '0');
      const psetDate = `${sY}-${sm}-${sd}`;
      this.setState({ sDate: psetDate });
      //let currentDate = getStartOfWeek(new Date());
      let currentDate = stateDate ? getStartOfWeek(tdate) : getStartOfWeek(new Date());
      const Y = currentDate.getFullYear();
      const m = String(currentDate.getMonth() + 1).padStart(2, '0');
      const d = String(currentDate.getDate()).padStart(2, '0');
      const setDate = `${Y}-${m}-${d}`;

      const fp = window.flatpickr('#weekPicker', {
         dateFormat: 'Y-m-d',
         locale: {
            ...window.flatpickr.l10ns.ko,
            firstDayOfWeek: 1, // 월요일 시작
         },
         weekNumbers: true,
         disableMobile: true,
         defaultDate: currentDate,
         maxDate,
         plugins: [new window.weekSelect({})],

         onChange: (selectedDates, dateStr, instance) => {
            if (selectedDates.length > 0) {
               const selectedDate = selectedDates[0];
               const selected = selectedDates[0];
               const today = new Date();
               const isToday = selected.getFullYear() === today.getFullYear() && selected.getMonth() === today.getMonth() && selected.getDate() === today.getDate();
               if (!isToday) {
                  currentDate = getStartOfWeek(selected);
               }
               // 오늘 날짜로 표시할 셀에 today 클래스 부여
               const allDays = instance.calendarContainer.querySelectorAll('.flatpickr-day');
               allDays.forEach((dayElem) => {
                  if (!dayElem.dateObj) return;
                  const dayDate = dayElem.dateObj;
                  dayElem.classList.remove('today', 'week', 'selected');

                  if (
                     dayDate.getFullYear() === today.getFullYear() &&
                     dayDate.getMonth() === today.getMonth() &&
                     dayDate.getDate() === today.getDate()
                  ) {
                     dayElem.classList.add('today');
                  }

                  // 선택된 주 계산
                  const weekStart = getStartOfWeek(selectedDate);
                  const weekEnd = getEndOfWeek(selectedDate);

                  if (dayDate >= weekStart && dayDate <= weekEnd) {
                     dayElem.classList.add('week', 'selected');
                  }
               });

               //const date = (selectedDates instanceof Date) ? selectedDates : new Date(selectedDates);
               const date = getStartOfWeek(selectedDate);               
               const Y = date.getFullYear();
               const m = String(date.getMonth() + 1).padStart(2, '0');
               const d = String(date.getDate()).padStart(2, '0');
               const selDate = `${Y}-${m}-${d}`;
               window.location.href=`/MyQuiz/${selDate}`;
               /*
               this.setState({ sDate: selDate, ord: 'all' });
               this.fetchAccessCheck(selDate, 'all');
               updateNavButtons();
               */
               //updateWeekText(currentDate);
            }
         },
         /*
         onDayCreate: function (dObj, dStr, fp, dayElem) {
            console.log('create:' + stateDate);
            const targetDate = new Date(stateDate + 'T00:00:00');
            // 날짜 비교용: yyyy-mm-dd로 변환
            const ymd = (date) =>
               date.toISOString().slice(0, 10);
            dayElem.classList.remove('today', 'week', 'selected');
            if (ymd(new Date(dayElem.dateObj)) === ymd(targetDate)) {
               dayElem.classList.add("today");
            }
         },
         */
         onMonthChange: updateHeader,
         onYearChange: updateHeader,
         appendTo: document.body, // 꼭 지정
         onOpen: function (selectedDates, dateStr, instance) {
            instance.calendarContainer.style.visibility = 'hidden';
            // 다음 프레임에 다시 표시
            requestAnimationFrame(() => {
               instance.calendarContainer.style.visibility = 'visible';
            });
            updateHeader(selectedDates, dateStr, instance);
         },
         onReady: function (selectedDates, dateStr, instance) {
            insertCloseButton(instance);
            updateNavButtons();
            //updateWeekText(currentDate);
         },
      });

      // 버튼 이벤트
      document.querySelector('.week-selector__nav--prev').addEventListener('click', function () {
         currentDate.setDate(currentDate.getDate() - 7);

         const year = currentDate.getFullYear();
         const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
         const day = String(currentDate.getDate()).padStart(2, '0');

         const formattedDate = `${year}-${month}-${day}`;         
         window.location.href=`/MyQuiz/${formattedDate}`;
         /*         
         fp.setDate(currentDate, true);
         updateNavButtons();
         */
         //updateWeekText(currentDate);
      });

      document.querySelector('.week-selector__nav--next').addEventListener('click', function () {
         const nextWeek = new Date(currentDate);
         nextWeek.setDate(currentDate.getDate() + 7);

         if (nextWeek <= maxDate) {
            currentDate = nextWeek;
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
            const day = String(currentDate.getDate()).padStart(2, '0');

            const formattedDate = `${year}-${month}-${day}`;         
            window.location.href=`/MyQuiz/${formattedDate}`;
            /*            
            fp.setDate(currentDate, true);
            updateNavButtons();
            */
            //updateWeekText(currentDate);
         }
      });
      const input = document.getElementById("weekPicker");
      input.addEventListener("focus", () => {
         setTimeout(() => input.blur(), 10);  // focus 후 바로 blur
      });
      $(document).on('click', '.quiz .btn', function () {
         // TODO:정답 1번으로 임의 설정
         const isCorrect = $(this).is($(this).closest('.quiz__a').find('.btn').first());
         const dataDate = $(this).attr('data-date');
         const dataAnswer = $(this).attr('data-answer');
         const dataGubn = $(this).attr('data-gubn');
         const dataUa = $(this).attr('data-ua');

         const $quiz = $(this).closest('.quiz');
         const $quizAnswer = $quiz.find('.quiz__a');

         // 상태 초기화
         $quiz.removeClass('quiz--pass quiz--fail');
         $quiz.find('.quiz__result').remove();
         $quiz.find('.quiz__result__txt').remove();
         $quiz.find('.quiz__result__btn').remove();
         $quiz.find('.btn').attr('disabled', true);
         $quiz.find('.quiz__explain__toggle').show();
         $(this).addClass('selected');
         const publicUrl = process.env.PUBLIC_URL;
         const quizWordUrl = publicUrl + '/api/setCrossAnswer.php?week=' + dataDate + '&word=' + dataUa + '|' + dataGubn + '&mode=quiz';
         const response = axios.get(quizWordUrl);
         const retData = response.data;

         if (dataAnswer == dataUa) {
            //정답일때

            //팝업열기
            popupOpen('popup--quizPass');

            $quiz.addClass('quiz--pass');

         } else {
            // 오답일때
            $quiz.addClass('quiz--fail');
            $(this).addClass('fail-ani'); //오답 interaction

            setTimeout(() => {
               //1초 후 노출
               $quiz.find('.date').after(`
                <button type="button" class="quiz__result__btn btn--retry">재도전</button>
                `);
            }, 1000);
         }
      });


      $(document).on('click', '.btn--retry', function () {
         const $quiz = $(this).closest('.quiz');
         $quiz.removeClass('quiz--fail');
         $quiz.find('.quiz__a .btn').removeClass('selected').removeClass('fail-ani').removeAttr('disabled');
         $quiz.find('.quiz__result__txt').remove();
         $quiz.find('.quiz__result__btn').remove();
         $quiz.find('.quiz__explain').removeClass('active');
         $quiz.find('.quiz__explain__toggle').hide();
      });
      //해설보기 토글
      $(document).on('click', '.quiz__explain__toggle', function () {
         const $btn = $(this);
         const $explain = $btn.prev('.quiz__explain');

         if ($btn.hasClass('active')) {
            $btn.removeClass('active');
            $explain.removeClass('active'); // hide();
            $btn.text('해설 보기');
         } else {
            $btn.addClass('active');
            $explain.addClass('active'); // show();
            $btn.text('해설 접기');
         }
      });

      function popupOpen(e) { return $("#" + e).fadeIn().css("display", "flex"), !1 }



      const cY = currentDate.getFullYear();
      const cm = String(currentDate.getMonth() + 1).padStart(2, '0');
      const cd = String(currentDate.getDate()).padStart(2, '0');
      const curDate = `${cY}-${cm}-${cd}`;

      let pocketTodayQuizCookie = getCookie('pocketTodayQuiz');
      const publicUrl = process.env.PUBLIC_URL;
      let quizCrossUrl = publicUrl + '/api/setCrossAnswer.php?week=' + getToday() + '&word=' + pocketTodayQuizCookie + '&mode=quiz';

      if (
         pocketTodayQuizCookie !== undefined &&
         pocketTodayQuizCookie !== null &&
         pocketTodayQuizCookie !== ''
      ) {
         axios.get(quizCrossUrl).then(response => {
            if (response.data == 'OK' && pocketTodayQuizCookie) {
               deleteCookie('pocketTodayQuiz');
            }
            this.fetchAccessCheck(setDate, 'all');
         });
      } else {
         this.fetchAccessCheck(setDate, 'all');
      }

   }

   handleButtonClick = async (targetIdx) => {

   };

   closeComboBx = (ord) => {
      let btnTxt = '전체';
      if (ord == 'O') btnTxt = '정답';
      else if (ord == 'X') btnTxt = '오답';
      $('.comboBx__btn').text(btnTxt);
      $('.comboBx__btn').removeClass('active');
      $('.comboBx__list').hide();
      this.setState(
         { ord: ord },
         () => {
            this.fetchAccessCheck('', ord);
         }
      );

   }
   /*
   popupOpen = (e) => { return $("#" + e).fadeIn().css("display", "flex"), !1 }
   answerQuiz = (e, index, date, answer, gubn, ua) => {
      console.log(date + ":" + answer + ":" + ua);
      const $quiz = $(e.currentTarget).closest('.quiz');
      // 상태 초기화
      $quiz.removeClass('quiz--pass quiz--fail');
      $(e.currentTarget).addClass('selected');

      const $quizExplain = $quiz.find('.quiz__explain__toggle');
      $quizExplain.show();

      const publicUrl = process.env.PUBLIC_URL;
      let quizCrossUrl = publicUrl + '/api/setCrossAnswer.php?week=' + date + '&word=' + ua + '|' + gubn + '&mode=quiz';
      console.log(quizCrossUrl);
      let response = axios.get(quizCrossUrl);
      if (answer == ua) {
         //정답일때

         //팝업열기
         this.popupOpen('popup--quizPass');
         $quiz.addClass('quiz--pass');
         //$quiz.find('.quiz__a .btn').attr('disabled', true);
      } else {
         // 오답일때
         $quiz.addClass('quiz--fail');
         $(e.currentTarget).addClass('fail-ani'); //오답 interaction
         //$quiz.find('.quiz__a .btn').attr('disabled', true);
         setTimeout(() => {
            //1초 후 노출
            $quiz.find('.date').after(`
                <button type="button" class="quiz__result__btn btn--retry">재도전</button>
                `);
         }, 1000);
      }

   }
   *///
   goToCross = () => {
      this.props.navigate(`/MyCross/${this.state.currDate}`);
   }
   render() {

      const { quizList, formMonth, weekusercnt, mw, formWeek } = this.state;
      const currentUrl = window.location.href;
      const structureData = {
         "@context": "https://schema.org",
         "@type": "WebSite",
         "name": "오늘의 용어 퀴즈 내역 - 지식포켓",
         "url": currentUrl,
      } 
      return (
         <>
            <Helmet>

               <title>오늘의 용어 퀴즈 내역 - 지식포켓</title>
               <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
               <meta name="description" content="오늘 풀었던 경제/시사 퀴즈 내역을 확인하고 복습하세요. 매일 퀴즈로 꾸준히 상식을 쌓을 수 있습니다."/>

               <meta property="og:type" content="website" />
               <meta property="og:site_name" content="지식포켓" />
               <meta property="og:title" content="오늘의 용어 퀴즈 내역 - 지식포켓" />
               <meta property="og:description" content="오늘 풀었던 경제/시사 퀴즈 내역을 확인하고 복습하세요. 매일 퀴즈로 꾸준히 상식을 쌓을 수 있습니다."/>
               <meta property="og:url" content={currentUrl} />
               <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />
               <meta property="og:locale" content="ko_KR" />

               <link rel="canonical" href={currentUrl}/>
               <script type="application/ld+json">
               { JSON.stringify(structureData)}
               </script>  
               
            </Helmet>          
            <main id="contents" data-page="my" className="page--quiz no-search-btn">
               <section className="section">
                  <div className="title-bx">
                     <h1 className="tit">퀴즈 내역</h1>
                  </div>

                  <div className="week-selector">
                     <form action="" className="week-selector__div" autocomplete="off">
                        <button type="button" className="week-selector__nav week-selector__nav--prev" title="이전" style={formMonth !== '' ? {} : { display: "none" }}></button>

                        <div className="week-selector__text">
                           <input type="text" className="input" id="weekPicker" autocomplete="off" inputmode="none" readonly />
                           {formMonth != '' ? (
                              <>
                                 <span>{formMonth}</span>월&nbsp;<span>{formWeek}</span>주차
                                 <i className="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                       <path d="M5.16667 7.75H3.44444V9.47222H5.16667V7.75ZM8.61111 7.75H6.88889V9.47222H8.61111V7.75ZM12.0556 7.75H10.3333V9.47222H12.0556V7.75ZM13.7778 1.72222H12.9167V0H11.1944V1.72222H4.30556V0H2.58333V1.72222H1.72222C1.26546 1.72222 0.827406 1.90367 0.504427 2.22665C0.181448 2.54963 0 2.98768 0 3.44444V15.5C0 15.9568 0.181448 16.3948 0.504427 16.7178C0.827406 17.0408 1.26546 17.2222 1.72222 17.2222H13.7778C14.2345 17.2222 14.6726 17.0408 14.9956 16.7178C15.3186 16.3948 15.5 15.9568 15.5 15.5V3.44444C15.5 2.98768 15.3186 2.54963 14.9956 2.22665C14.6726 1.90367 14.2345 1.72222 13.7778 1.72222ZM13.7778 15.5H1.72222V6.02778H13.7778V15.5Z" fill="#4553E7" />
                                    </svg>
                                 </i>
                              </>
                           ) : (<></>)}
                        </div>

                        <button type="button" className="week-selector__nav week-selector__nav--next" title="다음" style={formMonth !== '' ? {} : { display: "none" }}></button>
                     </form>
                  </div>
                  <div className="tab">
                     <ul className="tab-list">
                        <li><a href="#" onClick={(e) => e.preventDefault()} className="tab-link active"> 오늘의 용어 퀴즈 </a></li>
                        <li><a href={this.state.sDate ? `/MyCross/${this.state.sDate}` : `/MyCross`} className="tab-link">
                           주간 십자말풀이
                        </a></li>
                     </ul>
                  </div>
                  <></>

                  {(weekusercnt && weekusercnt > 0) ? (
                     <div className="container">
                        <div className="comboBx">
                           <button className="comboBx__btn">전체</button>
                           <ul className="comboBx__list">
                              <li><button onClick={() => this.closeComboBx('all')} type="button" className="link">전체</button></li>
                              <li><button onClick={() => this.closeComboBx('O')} type="button" className="link">정답</button></li>
                              <li><button onClick={() => this.closeComboBx('X')} type="button" className="link">오답</button></li>
                           </ul>
                        </div>
                     </div>
                  ) : (<></>)}
                  {(quizList && quizList.length > 0) ? (
                     <>
                        {quizList.map((item, index) => {
                           const dateStr = item.date;
                           const [year, month, day] = dateStr.split('-');
                           const formatted = `${parseInt(year)}년 ${parseInt(month)}월 ${parseInt(day)}일`;

                           let uc = false;
                           let ua = false;
                           let uep = 'none';

                           if (item.useranswer !== '') {
                              ua = true;
                              uep = '';
                           }

                           if (item.useranswer === item.answer) {
                              uc = true;
                           }

                           return (
                              item.gubn == 'o' ? (
                                 <article className={item.useranswer == '' ? "quiz" : (
                                    uc ? 'quiz quiz--pass' : 'quiz quiz--fail'
                                 )} data-quiz-id="1">
                                    <div className="wrap">
                                       <p className="date">{formatted}</p>
                                       {item.useranswer != '' && !uc ? (<button type="button" className="quiz__result__btn btn--retry">재도전</button>) : ('')}
                                       <h3 className="quiz__q">{item?.question}</h3>
                                       <div className="quiz__a quiz__a--ox">
                                          <button type="button" disabled={ua} data-date={item.date} data-answer={item.answer} data-gubn={item.gubn} data-ua='O' className={item.useranswer == 'O' ? "btn btn--o selected" : "btn btn--o"}> </button>
                                          <button type="button" disabled={ua} data-date={item.date} data-answer={item.answer} data-gubn={item.gubn} data-ua='X' className={item.useranswer == 'X' ? "btn btn--x selected" : "btn btn--x"}> </button>
                                       </div>

                                       <div className="quiz__explain">
                                          <p className="answer">정답 : {item?.answer}</p>
                                          <p className="explanation">{item?.description}</p>
                                       </div>
                                       <button type="button" className="quiz__explain__toggle" style={{ display: uep }}> 해설 보기 </button>
                                    </div>
                                 </article>
                              ) : (
                                 <article className={item.useranswer == '' ? "quiz" : (
                                    uc ? 'quiz quiz--pass' : 'quiz quiz--fail'
                                 )} data-quiz-id="1">
                                    <div className="wrap">
                                       <p className="date">{formatted}</p>
                                       {item.useranswer != '' && !uc ? (<button type="button" className="quiz__result__btn btn--retry">재도전</button>) : ('')}
                                       <h3 className="quiz__q">{item.question}</h3>
                                       <div className="quiz__a quiz__a--select">
                                          <button type="button" disabled={ua} data-date={item.date} data-answer={item.answer} data-gubn={item.gubn} data-ua='1' className={item.useranswer == '1' ? "btn selected" : "btn"}>{item.choice1}</button>
                                          <button type="button" disabled={ua} data-date={item.date} data-answer={item.answer} data-gubn={item.gubn} data-ua='2' className={item.useranswer == '2' ? "btn selected" : "btn"}>{item.choice2}</button>
                                          <button type="button" disabled={ua} data-date={item.date} data-answer={item.answer} data-gubn={item.gubn} data-ua='3' className={item.useranswer == '3' ? "btn selected" : "btn"}>{item.choice3}</button>
                                          <button type="button" disabled={ua} data-date={item.date} data-answer={item.answer} data-gubn={item.gubn} data-ua='4' className={item.useranswer == '4' ? "btn selected" : "btn"}>{item.choice4}</button>
                                       </div>

                                       <div className="quiz__explain">
                                          <p className="answer">정답 : {item?.answer}</p>
                                          <p className="explanation">{item?.description}</p>
                                       </div>
                                       <button type="button" className="quiz__explain__toggle" style={{ display: uep }}> 해설 보기 </button>
                                    </div>
                                 </article>
                              )
                           );
                        })}
                     </>
                  ) : (
                     <div className="quiz-null">
                        <p>퀴즈 내역이 없어요 😥 </p>
                        {mw?<a className="btn" href="/Today">퀴즈 풀러 가기</a>:<></>}
                     </div>
                  )}



               </section>
            </main>
            <Footer />
         </>
      );
   }
}

export default withRouter(MyQuiz);